import columns from '../../../../react-table/helpers/columns';
import ReportDefinitions from '../../../../common/config/ReportDefinitions';
import DirectionTypes from '../../../../common/redux/actions/types/DirectionTypes';
import UserTypes from '../../../../common/redux/actions/types/UserTypes';
import { totalRowRatio } from '../../../../react-table/helpers/rowTotals';

export const getDetailsTabNavOptions = direction => rowInfo => (
  rowInfo && rowInfo.row ? {
    reportId: ReportDefinitions.PAPER_FREE_MONITORING_POST_900_DETAILS.id,
    mainReportId: ReportDefinitions.PAPER_FREE_MONITORING_POST_900_SUMMARY.id,
    requestParams: {
      operator: rowInfo.row.originOperator,
      direction,
    },
    selectionCriteriaOptions: {
      includeSelectionCriteria: true,
    },
  } : {}
);

export const getOwnPropertyConditionalProps = userType => (state, rowInfo) => {
  if (rowInfo) {
    const { row } = rowInfo;
    if (row.globalScore === null) {
      row.globalScore = '-';
    }
    if (row.inboundOperatorScore === null) {
      row.inboundOperatorScore = '-';
    }
  }
  const className = userType !== UserTypes.IPC && rowInfo && rowInfo.original.ownOperator ? 'bg-blue-spindle' : '';
  return { className };
};

export const isOwnOperator = userType => rowInfo =>
  userType === UserTypes.IPC ||
  (rowInfo && rowInfo.original && rowInfo.original.ownOperator === true);

export default (data, userType) => {
  const {
    TextColumn,
    NonZeroPercentageColumn,
    PercentageColumn,
    NavigationWithFooterMultipleDrilldownOptionWithZeroPercentageColumn,
  } = columns(data);

  return [
    {
      Header: '',
      columns: [
        new TextColumn('Origin operator', 'originOperator').withTotalHeader('Total').withGetProps(getOwnPropertyConditionalProps(userType)).withWidth(180),
        new NavigationWithFooterMultipleDrilldownOptionWithZeroPercentageColumn(new PercentageColumn('Global score', 'globalScore').withTotalHeader(totalRowRatio(['globalPerformanceWeight', 'globalWeight'])).withGetProps(getOwnPropertyConditionalProps(userType)).withWidth(180), getDetailsTabNavOptions(DirectionTypes.INBOUND), isOwnOperator(userType)),
        new NonZeroPercentageColumn('', 'globalPerformanceWeight').withShow(false),
        new NonZeroPercentageColumn('', 'globalWeight').withShow(false),
        new NavigationWithFooterMultipleDrilldownOptionWithZeroPercentageColumn(new PercentageColumn('Inbound Operator score', 'inboundOperatorScore').withTotalHeader(totalRowRatio(['inboundOperatorPerformanceWeight', 'inboundOperatorWeight'])).withGetProps(getOwnPropertyConditionalProps(userType)).withWidth(200), getDetailsTabNavOptions(DirectionTypes.OUTBOUND)),
        new NonZeroPercentageColumn('', 'inboundOperatorWeight').withShow(false),
        new NonZeroPercentageColumn('', 'inboundOperatorPerformanceWeight').withShow(false),
      ],
      drillDownLink: {
        reportId: ReportDefinitions.PAPER_FREE_MONITORING_POST_900_DETAILS.id,
        mainReportId: ReportDefinitions.PAPER_FREE_MONITORING_POST_900_SUMMARY.id,
        requestParams: {
          isTotal: true,
          operator: '*',
        },
        selectionCriteriaOptions: {
          includeSelectionCriteria: true,
        },
      },
    },
  ];
};
